import React from 'react';
import { View, StyleSheet } from 'react-native';
import { ms, s, vs } from '../utils/responsive';

interface UserImageCircleProps {
  size?: number;
  children: React.ReactNode;
}

const UserImageCircle: React.FC<UserImageCircleProps> = ({ 
  size = 100,
  children 
}) => {
  return (
    <View style={[styles.container, { width: size, height: size }]}>
      <View style={[styles.circle, { width: size, height: size }]}>
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  circle: {
    borderRadius: ms(999),
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
  },
});

export default UserImageCircle;
